export default {
   'features': 'Recursos',
   'downloads': 'Downloads',
   'roadmap': 'Roadmap',
   'price': 'Preço',
   'donate': 'Doar',
   'feedback': 'Feedback',
   'panel': 'Painel de Controle',
};
